import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  Common,
  Permissionkeys,
  Spinner
} from '../../config/react'
import ReactSummernote from 'react-summernote'
import 'react-summernote/dist/react-summernote.css' // import styles
// import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/tooltip'
import 'summernote/dist/summernote.css'
const AddContentManagement = () => {
  const urlParams = useParams()
  const history = useHistory()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)

  const submitbtnRef = useRef()
  const validator = useRef(new SimpleReactValidator())

  const [Content, setContent] = useState()
  const [isForceUpdate, setForceUpdate] = useState(false)

  const [Inputs, setInputs] = useState({
    id: 0,
    title: '',
    content: '',
    htmlcontent: '',
    slug: '',
    meta_title: '',
    meta_description: '',
    meta_keywords: '',
    status: 0
  })

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.ContentManagement)) {
      history.push('/')
    }
    setIsAuth(true)
    setLoading(false)
    setForceUpdate(!isForceUpdate)
    document.title = Title.AddContentManagement
    if (urlParams.id !== undefined) {
      document.title = Title.EditContentManagement
      GetContentManagementDetail()
    }
  }, [urlParams.id])

  // useEffect(() => {
  //     if (Inputs.content.length > 0)
  //         setForceUpdate(!isForceUpdate);
  // }, [Inputs.content])

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status') setInputs({ ...Inputs, [prop]: event.target.checked })
    else setInputs({ ...Inputs, [prop]: event.target.value })
    setForceUpdate(!isForceUpdate)
  }

  const handleEditorChange = (e) => {
    setContent(e)
    // setInputs({ ...Inputs, ["content"]: e });
    setForceUpdate(!isForceUpdate)
  }

  const GetContentManagementDetail = () => {
    const param = {
      id: urlParams.id
    }
    if (urlParams.id !== undefined) {
      setLoading(true)
    }

    HttpService.postApi(API.GetContentManagementDetail, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        setInputs(response.data.result[0])
        setContent(response.data.result[0].content)
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    if (submitbtnRef.current) submitbtnRef.current.setAttribute('disabled', 'disabled')

    const param = {
      id: Inputs.id,
      title: Inputs.title,
      content: Content,
      slug: Inputs.slug,
      meta_title: Inputs.meta_title,
      meta_description: Inputs.meta_description,
      meta_keywords: Inputs.meta_keywords,
      status: Inputs.status
    }
    setLoading(true)
    if (urlParams.id === undefined) {
      HttpService.postApi(API.AddContentManagement, param).then((response) => {
        setLoading(false)
        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          submitbtnRef.current.removeAttribute('disabled')
          return
        }
        toast.success(Messages.RecordAdded)
        setForceUpdate(!isForceUpdate)
        history.push('/contentManagement')
      })
    } else {
      HttpService.postApi(API.UpdateContentManagement, param).then((response) => {
        setLoading(false)
        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          submitbtnRef.current.removeAttribute('disabled')
          return
        }
        toast.success(Messages.RecordUpdated)
        setForceUpdate(!isForceUpdate)
        history.push('/contentManagement')
      })
    }
  }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined
            ? Title.EditContentManagement
            : Title.AddContentManagement}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault()
                }}
                className="forms-sample"
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Page Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        min="2"
                        maxLength="255"
                        onChange={handleInputChanges('title')}
                        onKeyUp={handleInputChanges('title')}
                        onBlur={() => validator.current.showMessageFor('Page Title')}
                        defaultValue={Inputs.title}
                        placeholder="Page Title"
                      />
                      {validator.current.message('Page Title', Inputs.title, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges('status')}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* <div className="col-md-6">
                    <div className="form-group">
                      <label>Page Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="page_code"
                        min="1"
                        maxLength="10"
                        onChange={handleInputChanges('page_code')}
                        onKeyUp={handleInputChanges('page_code')}
                        onBlur={() => validator.current.showMessageFor('Page Code')}
                        defaultValue={Inputs.page_code}
                        placeholder="Page Code"
                      />
                      {validator.current.message(
                        'Page Code',
                        Inputs.page_code,
                        'required|alpha_num_space',
                        { className: 'error' }
                      )}
                    </div>
                  </div> */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Slug (URL)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="slug"
                        min="1"
                        maxLength="50"
                        onChange={handleInputChanges('slug')}
                        onKeyUp={handleInputChanges('slug')}
                        onBlur={() => validator.current.showMessageFor('Slug')}
                        defaultValue={Inputs.slug}
                        placeholder="Slug"
                      />
                      {validator.current.message('Slug', Inputs.slug, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Content</label>
                      <ReactSummernote
                        name="content"
                        value={Content}
                        options={{
                          height: 300, // Set editor height
                          toolbar: [
                            ['style', ['bold', 'italic', 'underline', 'clear']],
                            [
                              'font',
                              [
                                'fontname',
                                'fontsize',
                                'strikethrough',
                                'superscript',
                                'subscript',
                                'style'
                              ]
                            ],
                            ['para', ['ul', 'ol', 'paragraph']],
                            ['insert', ['link', 'picture', 'video']],
                            ['view', ['fullscreen', 'codeview', 'help']]
                          ],
                          fontNames: [
                            'Arial',
                            'Arial Black',
                            'Comic Sans MS',
                            'Courier New',
                            'Georgia',
                            'Times',
                            'Verdana'
                          ],
                          fontSizeUnits: ['px', 'pt', '%']
                        }}
                        onChange={(e) => {
                          handleEditorChange(e)
                        }}
                      />
                      {/* <input type="text" className="form-control " rows="5" value={Inputs.content} ></input> */}
                      {/* {validator.current.message('Page Content', Content, 'required', { className: 'error' })} */}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Meta Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="meta_title"
                        min="1"
                        maxLength="255"
                        onChange={handleInputChanges('meta_title')}
                        onKeyUp={handleInputChanges('meta_title')}
                        onBlur={() => validator.current.showMessageFor('Meta Title')}
                        defaultValue={Inputs.meta_title}
                        placeholder="Meta Title"
                      />
                      {validator.current.message('Meta Title', Inputs.meta_title, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Meta Keywords</label>
                      <input
                        className="form-control"
                        rows="5"
                        name="meta_keywords"
                        onChange={handleInputChanges('meta_keywords')}
                        onKeyUp={handleInputChanges('meta_keywords')}
                        onBlur={() => validator.current.showMessageFor('Meta Keywords')}
                        defaultValue={Inputs.meta_keywords}
                        placeholder="Meta Keywords"
                      ></input>
                      {validator.current.message(
                        'Meta Keywords',
                        Inputs.meta_keywords,
                        'required',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Meta Description</label>
                      <textarea
                        className="form-control"
                        rows="5"
                        name="meta_description"
                        onChange={handleInputChanges('meta_description')}
                        onKeyUp={handleInputChanges('meta_description')}
                        onBlur={() => validator.current.showMessageFor('Meta Description')}
                        defaultValue={Inputs.meta_description}
                        placeholder="Meta Description"
                      ></textarea>
                      {validator.current.message(
                        'Meta Description',
                        Inputs.meta_description,
                        'required',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <button
                      ref={submitbtnRef}
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/contentManagement"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddContentManagement
